import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="relative w-full py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-sm tracking-widest text-primary-400">FAQ</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-50 md:text-4xl">常见问题</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-400">
            关于漫镜的定位、评分与使用方式，这里都有答案。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-primary-500/60 bg-background-900" : "border-background-800/70 bg-background-900/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left whitespace-nowrap cursor-pointer"
                >
                  <span className={`text-sm font-medium ${open ? "text-primary-200" : "text-foreground-100"}`}>
                    {item.q}
                  </span>
                  <i
                    className={`text-primary-300 transition-transform duration-300 ${open ? "rotate-180" : ""} ${
                      open ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </button>
                {open && (
                  <p className="border-t border-background-800/60 px-4 py-4 text-sm leading-relaxed text-foreground-400">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}